<template>
    <Breadcrumbs main="Gallery" title="Masonry Gallery" />
    <div class="container-fluid">
        <div class="row">
            <masonryGallery />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
const masonryGallery = defineAsyncComponent(() => import("@/components/theme/gallery/masonry/masonryGallery.vue"))
</script>